import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CampaignTerminalsSelectableTable } from "./CampaignTerminalsSelectableTable";

export const CampaignTerminalsSelectableTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    // Fields have an index at the end of the name: field1, field2, ...
    const fieldIndex = field.name.at(field.name.length - 1);
    const valueToCheck = `sites${fieldIndex}`;
    const oldSites = `oldSites${fieldIndex}`;

    return (
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues[valueToCheck] !== currentValues[valueToCheck]}>
            {({ getFieldValue }) => (
                <Form.Item key={`${field.name}FormItem`} name={field.name}>
                    <CampaignTerminalsSelectableTable
                        key={field.name}
                        readOnly={readOnly}
                        oldSiteIds={getFieldValue(oldSites)}
                        siteIds={getFieldValue(valueToCheck)}
                    />
                </Form.Item>
            )}
        </Form.Item>
    );
};
